<div class="header">
  <div class="header-cont tables">
    <h2>{{ 'admin_themes.title' | translate }}</h2>
    <button mat-raised-button class="page-header-btns add-element" [routerLink]="['/lista-percorsi-tematici/nuovo-percorso']">
      <mat-icon>add_location</mat-icon>
    </button>
  </div>
</div>

<div class="single-section">
  <div class="section-cont tables">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'admin_themes.search_label' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event)" class="input-filter" [placeholder]="'placeholder' | translate">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>

<div class="admin-table">
  <table mat-table [dataSource]="dataSource">

    <!-- Theme name Column -->
    <ng-container matColumnDef="themes_name">
      <th mat-header-cell *matHeaderCellDef> {{ 'admin_themes.columns.path' | translate }} </th>
      <td mat-cell *matCellDef="let row">
        {{row.name[current_lang]}}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      [routerLink]="['/lista-percorsi-tematici/'+row.id]">
    </tr>
  </table>

  <mat-paginator class="mat-paginator-sticky" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
